import { Pipe, PipeTransform } from '@angular/core';
import { formatDate, formatNumber } from '@angular/common';
import { DateUtilities } from '@approot/utilities';

export type ScheduleFormat = 'date' | 'short' | 'long';

@Pipe({
  name: 'scheduleFormat'
})
export class ScheduleFormatPipe implements PipeTransform {
  transform(
    value: unknown,
    format: ScheduleFormat | undefined,
    columnName: string
  ): string {
    if (value === undefined) {
      return '';
    }
    if (typeof value === 'string') {
      if (DateUtilities.isCorrectFullDateFormat(value)) {
        // only try to convert the date if, its of a correct format
        return formatDate(value, 'd MMM y', 'en');
      }
    }
    if (typeof value === 'number') {
      if (format === 'short') {
        return columnName === 'notional' ||
          columnName === 'secondNotional' ||
          columnName.includes('flow')
          ? formatNumber(value, 'en-GB', '1.0-0')
          : formatNumber(value, 'en', '1.0-0');
      }

      if (format === 'long') {
        return formatNumber(value, 'en', '1.3-3');
      }
    }

    return String(value);
  }
}
